import { render, staticRenderFns } from "./FileFormat.vue?vue&type=template&id=17010c8a"
import script from "./FileFormat.vue?vue&type=script&lang=js"
export * from "./FileFormat.vue?vue&type=script&lang=js"
import style0 from "./FileFormat.vue?vue&type=style&index=0&id=17010c8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports